import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import './style.css'

const app = createApp(App)
const pinia = createPinia()

// 使用持久化插件
pinia.use(createPersistedState({
  storage: localStorage,
  key: (storeKey) => `language-assistant-${storeKey}`
}))

app.use(pinia)
app.use(router)
app.mount('#app')
